import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const angina: AnswerPathTreeNode = {
  path: 'angina',
  children: [{ path: 'details', nodeId: NodeIds.healthInsuredAnginaDetails }],
};
